import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from 'react-bootstrap';

import { getCurrentAlert, dismissLast } from 'rdx/alert';
import { history } from 'utils';

const types = {
  text: 'text',
  internalLink: 'internalLink',
  externalLink: 'externalLink',
};

const renderData = (data = []) => (
  <p>
    {data.map((el) => {
      switch (el.type) {
        case types.text:
          return <span>{el.content}</span>;
        case types.internalLink:
          return (
            <Alert.Link onClick={() => history.push(el.href)}>
              {el.content}
            </Alert.Link>
          );
        case types.externalLink:
          return (
            <span>
              <a href={el.href} target="_blank" rel="noopener noreferrer">
                {el.content}
              </a>
            </span>
          );
        default:
          return null;
      }
    })}
  </p>
);

const variants = {
  SUCCESS: 'success',
  ERROR: 'danger',
  WARNING: 'warning',
  INFO: 'primary',
};
const style = {
  position: 'fixed',
  textAlign: 'center',
  top: 0,
  left: 0,
  right: 0,
  fontWeight: 700,
  borderRadius: 0,
  zIndex: 1000,
};

function AlertComponent() {
  const dispatch = useDispatch();
  const alert = useSelector(getCurrentAlert);
  const closeAlert = () => dispatch(dismissLast());
  if (alert && alert.text) {
    return (
      <Alert
        style={style}
        variant={variants[alert.type]}
        dismissible={alert.dismissible}
        onClose={closeAlert}
      >
        {typeof alert.text === 'string'
          ? alert.text
          : alert.text.length > 0 && renderData(alert.text)}
      </Alert>
    );
  }
  return null;
}

export default AlertComponent;
